import { render } from "./specificSkills.vue?vue&type=template&id=32586c72"
import script from "./specificSkills.vue?vue&type=script&lang=js"
export * from "./specificSkills.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__